import React from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";

export const AppLayout: React.FC = () => {
  return (
    <AppSidebar>
      <Outlet />
    </AppSidebar>
  );
};
